<template>
    <wizard-panel name="interrelations" :status="panels.interrelations" :forceFull="forceChangeOnFull">
        <div class="wizard-panel__inner" v-if="forceChangeOnFull || panels.interrelations === 1">
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <div class="badge wizard-panel__badge">{{ qualification.name }}</div>

                <button v-if="!read" type="button" class="btn btn_action-second mb-24" @click.stop="openAdd(false)">
                    Добавить квалификацию
                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>


              <div style="position:relative;">
                <div style="position: absolute; margin-left: 200px; margin-top: 10px;">
                  <ul class="legend-list">
                    <li class="legend-list__item">
                                    <span class="legend-list__label">
                                        Связанные

                                        <icon-base viewBox="0 0 16 16" class="legend-list__icon"><icon-arrow-right-second/></icon-base>
                                    </span>
                    </li>
                    <li class="legend-list__item">
                                    <span class="legend-list__label legend-list__label_second">
                                        Родственные

                                        <icon-base viewBox="0 0 16 16" class="legend-list__icon"><icon-arrow-right-second/></icon-base>
                                    </span>
                    </li>
                  </ul>
                </div>
              </div>

                <tabs caption="Взаимосвязи" @clickOnTitle="forceFullWidth" :reset="forceChangeOnFull" :class="`interrelations-tabs`" :is-interrelations-tabs="true">
                    <tab title="Диаграмма">
                        <div class="diagram" v-if="forceChangeOnFull">
                            <ul class="legend-list diagram__legend-list mb-16">
                                <li class="legend-list__item ml-auto">
                                    <button class="legend-list__btn" :disabled="scale === 1" @click="scaleUp">
                                        <icon-base viewBox="0 0 12 12">
                                            <icon-action />
                                        </icon-base>
                                    </button>
                                    <button class="legend-list__btn ml-12" :disabled="scale === 0.1" @click="scaleDown">
                                        <icon-base viewBox="0 0 300 300">
                                            <icon-remove />
                                        </icon-base>
                                    </button>
                                </li>
                            </ul>

                            <tree v-if="!waitLoad" ref="tree" :read="read" :tree-data="treeInterrelations" @openProgramsDialog="loadPrograms" @openAddPanel="openAdd" />
                        </div>
                    </tab>
                    <tab title="Список">
                      <ul class="data-list">
                        <li class="data-list__item" v-for="(interrelation, key) in groupInterrelations" :key="key">
                          <section class="info">
                            <header class="info__head">
                              <div class="info__head-inner">
                                <div class="info__head-item">
                                  <p class="info__title">{{ relationsType[key] }}</p>
                                </div>
                              </div>
                            </header>

                            <div class="info__inner">
                              <div class="info__content">
                                <el-table
                                    cell-class-name="table__cell"
                                    class="table table_second table_in-panel"
                                    header-cell-class-name="table__title"
                                    max-height="400"
                                    ref="table"
                                    row-key="id"
                                    :data="interrelation"
                                >
                                  <el-table-column
                                      align="center"
                                      label="Код ОПД"
                                      prop="qualification_to.area_code"
                                      :width="80"
                                  />
                                  <el-table-column
                                      align="center"
                                      label="Код ВПД"
                                      prop="qualification_to.kind_code"
                                      :width="80"
                                  />
                                  <el-table-column
                                      align="center"
                                      label="Код ПК"
                                      prop="qualification_to.code"
                                      :width="100"
                                  />
                                  <el-table-column
                                      label="Название"
                                      prop="qualification_to.name"
                                      sortable
                                  />
                                  <el-table-column
                                      align="center"
                                      label="Уровень"
                                      prop="qualification_to.level"
                                      :width="80"
                                  />
                                  <el-table-column
                                      align="center"
                                      label="Подуровень"
                                      prop="qualification_to.level"
                                      :width="100"
                                  />
                                  <el-table-column
                                      align="center"
                                      label="Обр. прог"
                                      :width="80"
                                  >
                                    <template slot-scope="scope">
                                      <button v-if="scope.row.education_programs" type="button" class="settings-btn" @click="loadPrograms(scope.row)">
                                        <icon-base viewBox="0 0 12 14" class="settings-btn__icon"><icon-book /></icon-base>
                                      </button>
                                      <button v-else-if="!read" type="button" class="settings-btn" @click="loadPrograms(scope.row)">
                                        <icon-base width="10" height="10" viewBox="0 0 12 12"><icon-action /></icon-base>
                                      </button>
                                    </template>
                                  </el-table-column>
                                </el-table>
                              </div>
                            </div>
                          </section>
                        </li>
                      </ul>
                    </tab>
                </tabs>
            </div>
        </div>
        <div class="wizard-panel__inner" v-if="panels.interrelations === 2">
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <header class="panel-head">
                    <div class="panel-head__item">
                        <h2>Проекты квалификации</h2>
                    </div>

                    <div class="panel-head__buttons mt-48">
                        <button type="button" class="btn btn_primary" @click="saveInterrelationsByQualification">Добавить выбранные ПК</button>
                    </div>
                </header>

                <form
                    class="search-form"
                    @submit.prevent
                >
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': filterForQualification && filterForQualification.length !== 0 }" placeholder="Поиск" v-model="filterForQualification" @keydown.enter.prevent.stop>

                        <button v-if="filterForQualification && filterForQualification.length !== 0" class="search-form__reset" @click="filterForQualification = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <el-table
                    cell-class-name="table__cell"
                    class="table"
                    header-cell-class-name="table__title"
                    ref="qualificationsTables"
                    row-key="id"
                    :data="filteredQualifications"
                    :sort-orders="['ascending', 'descending']"
                    @selection-change="handleSelectionChangeForQualificationsAdding"
                >
                    <el-table-column
                        type="selection"
                        width="24"
                        :reserve-selection="true"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                    />
                </el-table>
            </div>
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <header class="panel-head">
                    <div class="panel-head__item">
                        <h2>Добавленные проекты квалификации</h2>
                    </div>

                    <div class="panel-head__buttons mt-48">
                        <button type="button" class="btn btn_danger" @click="deleteInterrelationsByQualification">Удалить выбранные ПК</button>
                    </div>
                </header>

                <h3>Связанные проекты квалификации</h3>

                <form
                    class="search-form"
                    @submit.prevent
                >
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': filterForQualificationRelated && filterForQualificationRelated.length !== 0 }" placeholder="Поиск" v-model="filterForQualificationRelated" @keydown.enter.prevent.stop>

                        <button v-if="filterForQualificationRelated && filterForQualificationRelated.length !== 0" class="search-form__reset" @click="filterForQualificationRelated = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <el-table
                    cell-class-name="table__cell"
                    class="table mb-24"
                    header-cell-class-name="table__title"
                    ref="relatedQualificationsTables"
                    row-key="id"
                    :data="filteredQualificationsRelated"
                    :sort-orders="['ascending', 'descending']"
                    @selection-change="handleSelectionChangeForRelatedQualificationsDeleting"
                >
                    <el-table-column
                        type="selection"
                        width="24"
                        :reserve-selection="true"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="qualification_to.name"
                        sortable
                    />
                </el-table>

                <h3>Родственные проекты квалификации</h3>

                <form
                    class="search-form"
                    @submit.prevent
                >
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': filterForQualificationInherited && filterForQualificationInherited.length !== 0 }" placeholder="Поиск" v-model="filterForQualificationInherited" @keydown.enter.prevent.stop>

                        <button v-if="filterForQualificationInherited && filterForQualificationInherited.length !== 0" class="search-form__reset" @click="filterForQualificationInherited = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <el-table
                    cell-class-name="table__cell"
                    class="table"
                    header-cell-class-name="table__title"
                    ref="inheritedQualificationsTables"
                    row-key="id"
                    :data="filteredQualificationsInherited"
                    :sort-orders="['ascending', 'descending']"
                    @selection-change="handleSelectionChangeForInheritedQualificationsDeleting"
                >
                    <el-table-column
                        type="selection"
                        width="24"
                        :reserve-selection="true"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="qualification_to.name"
                        sortable
                    />
                </el-table>
            </div>
        </div>

        <!-- DIALOGS -->
<!--        <programs-dialog-->
<!--            mode="interrelations"-->
<!--            v-if="activeTraining"-->
<!--            :qualificationId="activeTraining.qualification_to ? activeTraining.qualification_to.id : 0"-->
<!--            :trainingId="activeTraining.id"-->
<!--            :qualificationFromId="qualification.id"-->
<!--            @openExternalProgramDialog="showExternalProgramDialog = true"-->
<!--        />-->

        <TrainingProgramsDialog
        v-if="Object.keys(activeTraining).length > 0"
        :training="activeTraining"
        @close="activeTraining = {}"
        @openExternalProgramDialog="openExternalProgramDialog"
        />

        <external-programs-dialog
            :trainingId="activeTraining.id"
            v-if="showExternalProgramDialog"
            @closeExternalProgramsDialog="handleExternalProgramsDialogClosing"
        />
        <!-- /DIALOGS -->
    </wizard-panel>
</template>

<script>
import Vue from 'vue';
import MaskedInput from 'vue-masked-input';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import { debounce, groupBy } from '@/helpers';
import panel from '@/mixins/panel';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import ProgramsDialog from '@/components/Dialogs/ProgramsDialog';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import Tree from '@/components/Tree/Tree';
import WizardPanel from '@/components/WizardPanels/WizardPanel';
import ExternalProgramsDialog from "@/components/Dialogs/ExternalProgramsDialog";
import TrainingProgramsDialog from "@/components/Dialogs/TrainingProgramsDialog";

export default {
    mixins: [ panel ],
    props: {
        qualification: {
            required: true,
            type: Object
        },
        read: {
            type: Boolean,
            default: false
        },
    },
    components: {
      TrainingProgramsDialog,
      ExternalProgramsDialog,
        Accordion,
        AccordionItem,
        ProgramsDialog,
        Tab,
        Tabs,
        Tree,
        WizardPanel
    },
    data() {
        return {
            activeTraining: {},
            showExternalProgramDialog: false,
            filterForQualification: '',
            filterForQualificationInherited: '',
            filterForQualificationRelated: '',
            multipleSelectionForAdding: [],
            multipleSelectionForInheritedDeleting: [],
            multipleSelectionForRelatedDeleting: [],
            scale: 1,
            normalHeight: 0,
            bus: new Vue(),
            relationsType: {
                related: 'Связанные',
                inherited: 'Родственные'
            },
            forceChangeOnFull: true,
            idFromAdd: false,
            waitLoad: false,
            lastQualLoad: 0
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_PROGRAMS_BY_QUALIFICATION',
            'LOAD_PROGRAMS_BY_TRAINING',
            'SAVE_INTERRELATIONS_BY_QUALIFICATION',
            'LOAD_INTERRELATIONS_BY_QUALIFICATION',
            'DELETE_INTERRELATIONS_BY_QUALIFICATION'
        ]),
        ...mapMutations('editor', ['SET_QUALIFICATIONS', 'GROUP_QUALIFICATIONS']),

        openExternalProgramDialog() {
          this.showExternalProgramDialog = true;
        },
        closeExternalProgramDialog() {
          this.showExternalProgramDialog = false;
        },

        handleExternalProgramsDialogClosing(isUpdated) {
          if (isUpdated) {
            this.LOAD_PROGRAMS_BY_TRAINING(this.activeTraining.id);
          }
          this.closeExternalProgramDialog();
        },

        updateExternalPrograms(programs) {

        },

        loadPrograms(training) {
            this.activeTraining = training;
            this.elDialogs.programs = true;
        },
        openAdd(id = false) {
            this.elPanels.interrelations = 2;
            this.forceChangeOnFull = false;

            if (id === false) {
              this.LOAD_INTERRELATIONS_BY_QUALIFICATION(this.qualification.id);
              this.lastQualLoad = this.qualification.id;
            } else {
              this.LOAD_INTERRELATIONS_BY_QUALIFICATION([id, this.qualification.id]);
              this.lastQualLoad = id;
            }

            this.idFromAdd = id;
        },
        forceFullWidth(currentIndex){
            if (currentIndex !== 1) {
                this.forceChangeOnFull = true
                this.elPanels.interrelations = 2
            } else {
                this.forceChangeOnFull = false
                this.elPanels.interrelations = 1
            }
        },

        async saveInterrelationsByQualification() {
            const ids = this.multipleSelectionForAdding.map(selection => selection.id)
            const currentFromId = this.idFromAdd ? this.idFromAdd : this.qualification.id;

            for (const id of ids) {
                const params = {
                    'qualification_to': id,
                    'parent_id': this.qualification.id
                }
                const options = {
                    qualificationFromId: currentFromId,
                    params
                }
                const status = await this.SAVE_INTERRELATIONS_BY_QUALIFICATION(options)
                console.log(this.multipleSelectionForAdding.find(el => el.id === id));
                if (status === 409) this.TOGGLE_ALERT({open: true, text: `К сожалению установить взаимосвязь "${this.multipleSelectionForAdding.find(el => el.id === id).name}" не удается, поскольку они уже связаны и нельзя установить цикличную взаимосвязь`})
                else if (status === 422) this.TOGGLE_ALERT({open: true, text: `К сожалению установить взаимосвязь "${this.multipleSelectionForAdding.find(el => el.id === id).name}" не удается, поскольку не указана ПК, к которой переход`})
            }

            await this.LOAD_INTERRELATIONS_BY_QUALIFICATION([currentFromId, this.qualification.id]);
            this.lastQualLoad = currentFromId;

            // const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            // await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, { inherited: (this.groupInterrelations.inherited ? this.groupInterrelations.inherited.length : 0), related: (this.groupInterrelations.related ? this.groupInterrelations.related.length : 0) }) : qualification))
            // await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.$refs.qualificationsTables.clearSelection();
        },
        async deleteInterrelationsByQualification() {
            const ids = this.multipleSelectionForDeleting.map(selection => selection.id)
            const currentFromId = this.idFromAdd ? this.idFromAdd : this.qualification.id;

            const params = {
                qualificationId: currentFromId,
                parent_id: this.qualification.id,
                ids
            }

            await this.DELETE_INTERRELATIONS_BY_QUALIFICATION(params);

            await this.LOAD_INTERRELATIONS_BY_QUALIFICATION([currentFromId, this.qualification.id]);
            this.lastQualLoad = currentFromId;

            // const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            // await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, { inherited: (this.groupInterrelations.inherited ? this.groupInterrelations.inherited.length : 0), related: (this.groupInterrelations.related ? this.groupInterrelations.related.length : 0) }) : qualification))
            // await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.$refs.relatedQualificationsTables.clearSelection();
            this.$refs.inheritedQualificationsTables.clearSelection();
        },

        handleSelectionChangeForQualificationsAdding(val) {
            this.multipleSelectionForAdding = val
        },
        handleSelectionChangeForInheritedQualificationsDeleting(val) {
            this.multipleSelectionForInheritedDeleting = val
        },
        handleSelectionChangeForRelatedQualificationsDeleting(val) {
            this.multipleSelectionForRelatedDeleting = val
        },

        scaleUp() {
            this.scale = (this.scale * 10 + 1) / 10
        },
        scaleDown() {
            this.scale = (this.scale * 10 - 1) / 10
        },
        selectDiagramTab() {
          const el = document.querySelectorAll('.interrelations-tabs .tabs__list .tabs__item')[0]

          if (el !== undefined) {
            el.dispatchEvent(new Event('click'))
          }
        },
        selectListTab() {
          const el = document.querySelectorAll('.interrelations-tabs .tabs__list .tabs__item')[1]

          if (el !== undefined) {
            el.dispatchEvent(new Event('click'))
          }
        },
        fixInterrelationsHeights() {
          const treeBranches = document.querySelectorAll('.tree .tree__branch')

          for (let i = treeBranches.length - 1; i >= 0; i--) {
            let treeBranch = treeBranches[i];

            if (treeBranch.children.length === 2) {
              let relatedEl = treeBranch.children[0]

              relatedEl.style = ''

              let inheritedEl = treeBranch.children[1]

              inheritedEl.style = ''

              if (relatedEl !== undefined && inheritedEl !== undefined) {
                if (relatedEl && inheritedEl /*&& !this.hasInlineStyle(relatedEl, 'height') && !this.hasInlineStyle(inheritedEl, 'height')*/) {
                  if (relatedEl.scrollHeight >= inheritedEl.scrollHeight) {
                    inheritedEl.style.height = relatedEl.scrollHeight + 'px'
                  } else {
                    relatedEl.style.height = inheritedEl.scrollHeight + 'px'
                  }
                }
              }
            }
          }
        },
        hasInlineStyle(obj, style) {
          var attrs = obj.getAttribute('style');

          if(attrs === null) return false;

          if(typeof attrs == 'object') attrs = attrs.cssText;

          var styles = attrs.split(';');

          for(var x = 0; x < styles.length; x++) {
            var attr = styles[x].split(':')[0].replace(/^\s+|\s+$/g,"").toLowerCase();

            if(attr == style) {
              return true;
            }
          }

          return false;
        }
    },
    computed: {
        ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_KIND_BY_ID']),
        ...mapState('editor', ['groupItemsBy', 'interrelationsByQualification', 'qualifications', 'intersectionsPaths']),

        input: {
            get() {
                return this.searchValue;
            },
            set: debounce(function(val) {
                this.searchValue = val;
            }, 30)
        },
        groupInterrelations() {
            return groupBy('relation_type', this.interrelationsByQualification);
        },
        treeInterrelations() {
            const tree = {
                qualification_to: {
                    code: this.qualification.code,
                    name: this.qualification.name,
                    trainings: this.interrelationsByQualification
                }
            }

            return tree;
        },

        multipleSelectionForDeleting() {
            return this.multipleSelectionForRelatedDeleting.concat(this.multipleSelectionForInheritedDeleting)
        },

        filteredQualifications() {
            const currentQualId = this.idFromAdd ? this.idFromAdd : this.qualification.id;

            const tempItems = [].concat(this.qualifications)

            const pathEl = this.intersectionsPaths.filter(el => el.id === currentQualId);
            const path = pathEl.length > 0 && pathEl[0] !== undefined ? pathEl[0].path : [];

            return tempItems.filter(qualification => this.qualification.id !== qualification.id && currentQualId !== qualification.id && path.indexOf(qualification.id) === -1
            && !this.interrelationsByQualification.map(interrelationQualification => interrelationQualification.qualification_to.id).includes(qualification.id)
            && String(qualification.name).toLowerCase().includes(this.filterForQualification.toLowerCase()))
        },
        filteredQualificationsInherited() {
            return this.groupInterrelations.inherited
            ? this.groupInterrelations.inherited.filter(qualification => qualification.qualification_to.name.toLowerCase().includes(this.filterForQualificationInherited.toLowerCase()))
            : []
        },
        filteredQualificationsRelated() {
            return this.groupInterrelations.related
            ? this.groupInterrelations.related.filter(qualification => qualification.qualification_to.name.toLowerCase().includes(this.filterForQualificationRelated.toLowerCase()))
            : []
        },
    },
  watch: {
        scale: function(val, oldVal) {
            const tree = this.$refs.tree.$el

            if (oldVal === 1) this.normalHeight = tree.scrollHeight
            tree.style.transform = `scale(${val})`
            tree.style.height = `${ this.normalHeight * val }px`
        },
        forceChangeOnFull: function(val) {
            if (!val) {
               this.scale = 1
            }
        },
        async 'elPanels.interrelations' (val) {
          if (val === 0) {
            this.lastQualLoad = 0;
          }

          if (val === 1) {
            this.waitLoad = true;

            if (this.lastQualLoad !== this.qualification.id) {
              await this.LOAD_INTERRELATIONS_BY_QUALIFICATION(this.qualification.id);

              this.lastQualLoad = this.qualification.id;
            }

            this.waitLoad = false;

            //this.fixInterrelationsHeights();
          }

          if (val === 2 && !this.waitLoad) {
            this.selectDiagramTab();
            this.forceChangeOnFull = true;
          }
        },
    },
}
</script>